const n = {
  styleOverrides: {
    root: ({ theme: o }) => ({
      background: o.palette.secondary.main,
      button: {
        background: "none",
        color: o.palette.secondary.contrastText,
        boxShadow: "none",
        "&:hover": {
          background: "none",
          boxShadow: "none"
        },
        "&.Mui-focusVisible": {
          background: "none",
          boxShadow: "none"
        }
      }
    })
  }
};
export {
  n as default
};
